import { InteractiveTable, Tooltip, useInteractiveTableContext } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../../../translations';
import { SurveyPreInterviewTemplateTableBean } from '../SurveyPreInterviewTemplateInteractiveTable.types';
import { addEmptyRow } from '../SurveyPreInterviewTemplateInteractiveTable.utils';

const TABLE_MAX_ROWS = 20;

export const QuestionAddRowButton = (): JSX.Element => {
   const { getValues } = useInteractiveTableContext<SurveyPreInterviewTemplateTableBean>();
   const rowsLimitReached = getValues().length >= TABLE_MAX_ROWS;

   return (
      <Tooltip
         content={generalSettingsTranslationKeys.survey.preInterview.form.interactiveTable.buttons.addRow.disabled}
         testId={'addQuestion'}
         disabled={!rowsLimitReached}
      >
         <InteractiveTable.AddRowButton
            label={generalSettingsTranslationKeys.survey.preInterview.form.interactiveTable.buttons.addRow.label}
            onAddRow={addEmptyRow}
            behavior={'append'}
            disabled={rowsLimitReached}
         />
      </Tooltip>
   );
};
